// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2168":"8dfac3d8","5833":"a7f8a8f3"}[chunkId] + ".chunk.css";
};